export const removeNotVisibleNodesFromFlatList = (nodes) => {
  return nodes.filter((node) => node.visible);
};
